module.exports = __webpack_public_path__ + "img/maxeon-logo.c0ed50e1.svg";